import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "assets/scss/argon-dashboard/custom/_fonts.scss";

import { AuthProvider } from "./auth/AuthContext";
import Protected from "./auth/Protected";

import Login from "./Login";
import UserLayout from "layouts/User";
import AuthLayout from "layouts/Auth";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/*" element={<AuthLayout />} />

        {/* ต้องล็อกอินก่อนถึงเข้า layout หลักได้ */}
        <Route element={<Protected />}>
          <Route path="/*" element={<UserLayout />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>,
);
